import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import Modal from "@/components/modal"
import CardContainer from "@/components/card-container"
import CardButton from "@/components/card-button"
import Tooltip from "@/components/tooltip"

interface Option<T> {
  value: T
  icon: IconDefinition
  title: string
  help: string
}

interface Props<T> {
  title: string
  options: Option<T>[]
  footer?: string
  onClose: () => void
  onSelect: (value: T) => void
}

//Two ways of filling a role (members or dashboard scope), the first one highlighted
export default function RoleChoiceModal<T>({ title, options, footer, onClose, onSelect }: Props<T>) {
  return (
    <Modal title={title} onClose={onClose} isCloseButtonVisible>
      <CardContainer>
        {options.map((option, index) => (
          <Tooltip key={option.title} text={option.help} width={280} usePortal>
            <CardButton
              isCta={index === 0}
              icon={option.icon}
              title={option.title}
              onClick={() => onSelect(option.value)}
            />
          </Tooltip>
        ))}
      </CardContainer>
      {footer && <p className="grey-t text-center">{footer}</p>}
    </Modal>
  )
}
